module.exports = __webpack_public_path__ + "static/img/1.ffbd8af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/eng/1.png
// module id = 2fn4
// module chunks = 0